import { emailValid, mobilePhoneValid } from 'helpers/validation';

export const PAYTO_LOG_TAG = 'PAYTO';

// DEV-1401: treats null, undefined, 0, and '' as the same no-limit /
// null-equivalent state for createPayToLimit / amendPayToLimit business
// rules. Deliberately does not use lodash's isEmpty, which returns true for
// ANY number (isEmpty(5) === true) and would misclassify every positive
// limit as null-equivalent.
export const isPayToLimitNullEquivalent = (value) =>
  value === null || value === undefined || value === 0 || value === '';

export const ADD_NEW_PAYTO_ACCOUNT_MAX_AMOUNT_DEFAULT = 6000;
export const BSB_NUMBER_LENGTH = 6;
export const ACCOUNT_AGREEMENTS_MAX_SIZE = 2;

export const PAY_BY_PAYTO_AMOUNT_MIN_LIMIT = 20;
export const PAY_BY_PAYTO_AMOUNT_MAX_LIMIT = 6000;

export const PAYID_TYPE_MOBILE = 'phonenumber';
export const PAYID_TYPE_EMAIL = 'email';

export const FORM_ADD_PAYTO_MAX_AMOUNT_NAME = 'form-add-payto-max-amount';
export const FORM_ADD_PAYTO_MAX_AMOUNT_FIELD = {
  name: FORM_ADD_PAYTO_MAX_AMOUNT_NAME,
  type: 'text',
  placeholder: '0.00',
  isRequired: false,
  isReadOnly: false,
  msgMaxLimited: '',
  msgMinLimited: 'form_input_max_amount_validation_1',
  msgRequired: '',
};

export const FORM_ADD_PAYTO_BSB_NAME = 'form-add-payto-bsb-name';
export const FORM_ADD_PAYTO_BANK_NAME_NAME = 'form-add-payto-bank-name';
export const FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME =
  'form-add-payto-account-number';
export const FORM_ADD_PAYTO_PAYID_TYPE_NAME = 'form-add-payto-payid-type-name';
export const FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME =
  'form-add-payto-payid-mobile-email-name';
export const RESET_FORM_ADD_PAYTO_ACCOUNT_STORE = {
  [FORM_ADD_PAYTO_MAX_AMOUNT_NAME]: '',
  [FORM_ADD_PAYTO_BSB_NAME]: '',
  [FORM_ADD_PAYTO_BANK_NAME_NAME]: '',
  [FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME]: '',
  [FORM_ADD_PAYTO_PAYID_TYPE_NAME]: PAYID_TYPE_MOBILE,
  [FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME]: '',
};
export const FORM_ADD_PAYTO_ACCOUNT_VALIDATION_INITIAL = {
  [FORM_ADD_PAYTO_MAX_AMOUNT_NAME]: '',
  [FORM_ADD_PAYTO_BSB_NAME]: '',
  [FORM_ADD_PAYTO_BANK_NAME_NAME]: '',
  [FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME]: '',
  [FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME]: '',
};

export const FORM_ADD_PAYTO_BSB_FIELD = {
  label: 'BSB',
  name: FORM_ADD_PAYTO_BSB_NAME,
  type: 'text',
  placeholder: 'form_input_bsb_number_placeholder',
  tooltip: ``,
  isRequired: false,
  isReadOnly: false,
  msgNumberInvalid: 'form_input_bsb_number_validation',
  msgNumberInvalid2: 'form_input_bsb_number_validation_2',
  msgExisted: '',
  msgInvalid: 'form_input_bsb_max_number_validation',
  msgRequired: 'form_required',
};
export const FORM_ADD_BANK_NAME_FIELD = {
  label: 'label_bank_name',
  name: FORM_ADD_PAYTO_BANK_NAME_NAME,
  type: 'text',
  placeholder: '',
  tooltip: ``,
  isRequired: false,
  isReadOnly: true,
  msgInvalid: '',
  msgRequired: '',
};
export const FORM_ADD_PAYTO_ACCOUNT_NUMBER_FIELD = {
  label: 'label_bank_account_number',
  name: FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME,
  type: 'text',
  placeholder: 'form_input_account_number_placeholder',
  tooltip: ``,
  isRequired: false,
  isReadOnly: false,
  msgNumberInvalid: 'form_mobile_invalid_4',
  msgExisted: '',
  msgInvalid: 'form_input_payto_agreement_account_number_max_number_validation',
  msgRequired: 'form_required',
};

export const FORM_ADD_PAYTO_PAYID_TYPE_FIELD = {
  label: 'label_payid_type',
  name: FORM_ADD_PAYTO_PAYID_TYPE_NAME,
  type: 'text',
  placeholder: 'form_placeholder_please_select',
  isRequired: false,
  isReadOnly: false,
  msgRequired: 'form_required',
};
export const FORM_ADD_PAYTO_PAYID_EMAIL_FIELD = {
  label: '',
  name: FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME,
  type: 'email',
  // placeholder: 'EX: ABC@MAIL.COM',
  placeholder: '',
  isRequired: false,
  isReadOnly: false,
  // msgInvalid: 'form_email_invalid',
  msgInvalid: 'form_input_payid_invalid_format',
  msgExisted: 'form_email_existed',
  msgRequired: 'form_required',
  msgNotSupported: 'form_payid_not_supported_validation',
  checkValidFn: emailValid,
};
export const FORM_ADD_PAYTO_PAYID_MOBILE_FIELD = {
  label: '',
  name: FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME,
  type: 'tel',
  // placeholder: 'EX: 04123456789',
  placeholder: '',
  isRequired: false,
  isReadOnly: false,
  // msgInvalid: 'form_mobile_invalid_2',
  msgInvalid: 'form_input_payid_invalid_format',
  // msgStartWith: 'form_mobile_invalid_3',
  msgStartWith: 'form_input_payid_invalid_format',
  msgRequired: 'form_required',
  msgNotSupported: 'form_payid_not_supported_validation',
  checkValidFn: mobilePhoneValid,
};

export const FORM_ADD_PAYTO_LIMIT_PER_AGREEMENT_NAME =
  'form_add_payto_limit_per_agreement_name';
export const FORM_ADD_PAYTO_LIMIT_PER_AGREEMENT_FIELD = {
  label: 'label_payto_limit_per_agreement_title',
  name: FORM_ADD_PAYTO_LIMIT_PER_AGREEMENT_NAME,
  type: 'text',
  tooltip: 'label_payto_limit_per_agreement_tooltip',
  isRequired: false,
  isReadOnly: false,
  msgInvalid: '',
  msgRequired: '',
};

export const PAYID_TYPE_OPTION_DATA = [
  {
    key: PAYID_TYPE_MOBILE,
    value: 'form_mobile_3',
  },
  {
    key: PAYID_TYPE_EMAIL,
    value: 'form_email',
  },
];
export const FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_FIELD_REFERENCES = {
  [PAYID_TYPE_MOBILE]: FORM_ADD_PAYTO_PAYID_MOBILE_FIELD,
  [PAYID_TYPE_EMAIL]: FORM_ADD_PAYTO_PAYID_EMAIL_FIELD,
};

export const PAYTO_ACCOUNT_CREATED_STATUS = 'Created';
export const PAYTO_ACCOUNT_INPROGRESS_STATUS = 'InProgress';
export const PAYTO_ACCOUNT_ACTIVE_STATUS = 'Active';
export const PAYTO_ACCOUNT_REJECTED_STATUS = 'Rejected';
export const PAYTO_ACCOUNT_CANCELLED_STATUS = 'Cancelled';

export const PAYTO_ACCOUNT_AMEND_COMPLETED_STATUS = 'COMPLETED';
export const PAYTO_ACCOUNT_AMEND_DECLINED_STATUS = 'DECLINED';
export const PAYTO_ACCOUNT_AMEND_EXPIRED_STATUS = 'EXPIRED';
export const PAYTO_ACCOUNT_AMEND_REJECTED_STATUS = 'REJECTED';

export const PAYTO_ERROR_CODE_PTE_0100 = 'popup_payto_agreement_error_pte_0100';
export const PAYTO_ERROR_CODE_PTE_0101 = 'popup_payto_agreement_error_pte_0101';
export const PAYTO_ERROR_CODE_PTE_0102 = 'popup_payto_agreement_error_pte_0102';
export const PAYTO_ERROR_CODE_PTE_0200 =
  'popup_payto_initiation_error_pte_0200';
export const PAYTO_ERROR_CODE_PTE_0201 =
  'popup_payto_initiation_error_pte_0201';
export const PAYTO_ERROR_CODE_PTE_0202 =
  'popup_payto_initiation_error_pte_0202';
export const PAYTO_ERROR_CODE_PTE_0203 =
  'popup_payto_initiation_error_pte_0203';
export const PAYTO_ERROR_CODE_PTE_0204 =
  'popup_payto_initiation_error_pte_0204';
export const PAYTO_ERROR_CODE_PTE_0300 = 'popup_payto_amendment_error_pte_0300';
export const PAYTO_ERROR_CODE_OTP_E001 = 'popup_payto_otp_error_otp_e001';
export const PAYTO_ERROR_CODE_OTP_E002 = 'popup_payto_otp_error_otp_e002';
export const PAYTO_ERROR_CODE_MAPPING = {
  PTE_0100: PAYTO_ERROR_CODE_PTE_0100,
  PTE_0101: PAYTO_ERROR_CODE_PTE_0101,
  PTE_0102: PAYTO_ERROR_CODE_PTE_0102,
  PTE_0200: PAYTO_ERROR_CODE_PTE_0200,
  PTE_0201: PAYTO_ERROR_CODE_PTE_0201,
  PTE_0202: PAYTO_ERROR_CODE_PTE_0202,
  PTE_0203: PAYTO_ERROR_CODE_PTE_0203,
  PTE_0204: PAYTO_ERROR_CODE_PTE_0204,
  PTE_0300: PAYTO_ERROR_CODE_PTE_0300,
  OTP_E001: PAYTO_ERROR_CODE_OTP_E001,
  OTP_E002: PAYTO_ERROR_CODE_OTP_E002,
};

export const PAYTO_ERROR_CODE_PTE_0100_TITLE =
  'popup_payto_agreement_error_pte_0100_title';
export const PAYTO_ERROR_CODE_PTE_0101_TITLE =
  'popup_payto_agreement_error_pte_0101_title';
export const PAYTO_ERROR_CODE_PTE_0102_TITLE =
  'popup_payto_agreement_error_pte_0102_title';
export const PAYTO_ERROR_CODE_PTE_0200_TITLE =
  'popup_payto_initiation_error_pte_0200_title';
export const PAYTO_ERROR_CODE_PTE_0201_TITLE =
  'popup_payto_initiation_error_pte_0201_title';
export const PAYTO_ERROR_CODE_PTE_0202_TITLE =
  'popup_payto_initiation_error_pte_0202_title';
export const PAYTO_ERROR_CODE_PTE_0203_TITLE =
  'popup_payto_initiation_error_pte_0203_title';
export const PAYTO_ERROR_CODE_PTE_0204_TITLE =
  'popup_payto_initiation_error_pte_0204_title';
export const PAYTO_ERROR_CODE_PTE_0300_TITLE =
  'popup_payto_amendment_error_pte_0300_title';
export const PAYTO_ERROR_CODE_OTP_E001_TITLE =
  'popup_payto_otp_error_otp_e001_title';
export const PAYTO_ERROR_CODE_OTP_E002_TITLE =
  'popup_payto_otp_error_otp_e002_title';
export const PAYTO_ERROR_CODE_MAPPING_TITLE = {
  PTE_0100: PAYTO_ERROR_CODE_PTE_0100_TITLE,
  PTE_0101: PAYTO_ERROR_CODE_PTE_0101_TITLE,
  PTE_0102: PAYTO_ERROR_CODE_PTE_0102_TITLE,
  PTE_0200: PAYTO_ERROR_CODE_PTE_0200_TITLE,
  PTE_0201: PAYTO_ERROR_CODE_PTE_0201_TITLE,
  PTE_0202: PAYTO_ERROR_CODE_PTE_0202_TITLE,
  PTE_0203: PAYTO_ERROR_CODE_PTE_0203_TITLE,
  PTE_0204: PAYTO_ERROR_CODE_PTE_0204_TITLE,
  PTE_0300: PAYTO_ERROR_CODE_PTE_0300_TITLE,
  OTP_E001: PAYTO_ERROR_CODE_OTP_E001_TITLE,
  OTP_E002: PAYTO_ERROR_CODE_OTP_E002_TITLE,
};

export const PAYTO_VALIDATE_BANK_VALIDATION_MTCH =
  'form_payto_validate_bank_validation_mtch';
export const PAYTO_VALIDATE_BANK_VALIDATION_CMTC =
  'form_payto_validate_bank_validation_cmtc';
export const PAYTO_VALIDATE_BANK_VALIDATION_NMTC =
  'form_payto_validate_bank_validation_nmtc';
export const PAYTO_VALIDATE_BANK_VALIDATION_VFYD =
  'form_payto_validate_bank_validation_vfyd';
export const PAYTO_VALIDATE_BANK_VALIDATION_NFND =
  'form_payto_validate_bank_validation_nfnd';
export const PAYTO_VALIDATE_BANK_VALIDATION_CLSD =
  'form_payto_validate_bank_validation_clsd';
export const PAYTO_VALIDATE_BANK_VALIDATION_RESULT_CODE = {
  MTCH: PAYTO_VALIDATE_BANK_VALIDATION_MTCH,
  CMTC: PAYTO_VALIDATE_BANK_VALIDATION_CMTC,
  NMTC: PAYTO_VALIDATE_BANK_VALIDATION_NMTC,
  VFYD: PAYTO_VALIDATE_BANK_VALIDATION_VFYD,
  NFND: PAYTO_VALIDATE_BANK_VALIDATION_NFND,
  CLSD: PAYTO_VALIDATE_BANK_VALIDATION_CLSD,
};

// resultCode values that mean the bank/PayID details were matched/verified successfully.
// DEV-1401: ERRR added -- client-confirmed as a genuine resultCode value the
// validate-BSB/validate-PayID API returns, to be treated as a successful
// validation. Not previously present in either the success or failure list
// (an unmatched code fell through to the generic invalid-message path), so
// there was no failure/unknown branch to remove it from.
export const PAYTO_VALIDATE_BANK_VALIDATION_SUCCESS_RESULT_CODES = [
  'MTCH',
  'VFYD',
  'CMTC',
  'NMTC',
  'ERRR',
];
// resultCode values that mean the bank/PayID details are known to be invalid.
export const PAYTO_VALIDATE_BANK_VALIDATION_FAILURE_RESULT_CODES = [
  'NFND',
  'CLSD',
];

export const accountBsbConfig = {
  required: false,
  visible: true,
  apiEnabled: true,
  example: '',
  format: `[\"###-###\"]`,
  regex: '^\\d+$',
  max: 6,
  min: 6,
  name: '',
};
export const accountNumberConfig = {
  required: false,
  visible: true, // depend BSB
  apiEnabled: true,
  example: '',
  // format: `[\"123456789\"]`,
  format: `[\"############\"]`,
  regex: '^\\d+$',
  max: 12,
  min: 6,
  name: '',
};
export const accountMobileConfig = {
  visible: true,
  required: false,
  prefix: `[\"04\"]`,
  format: `[\"#### ### ###\"]`,
  example: '',
  max: 10,
  min: 10,
};

export const MAX_AMOUNT_OPTION_DATA = [
  {
    key: 'AUD 1000',
    value: '1000',
  },
  {
    key: 'AUD 2000',
    value: '2000',
  },
  {
    key: 'AUD 3000',
    value: '3000',
  },
  {
    key: 'AUD 4000',
    value: '4000',
  },
  {
    key: 'AUD 5000',
    value: '5000',
  },
  {
    key: 'AUD 6000',
    value: '6000',
  },
];
